// extracted by mini-css-extract-plugin
export default {"thankYouBox":"thankYouBox_thankYouBox__dh4Ml","thankYouBox__text":"thankYouBox_thankYouBox__text__S1ZST"};